import styled from "styled-components";
import { Colors } from "../../utilities/colors";

const RadioButtonGroup = styled.label`
  display: flex;
  align-items: flex-start;
  margin-bottom: ${(props) => props.$margin || "0px"};
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  // opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
`;

const RadioButton = styled.input`
  appearance: none;
  -webkit-appearance: none;

  width: 22px;
  height: 22px;
  min-width: 22px;
  margin: 0;
  margin-top: 1px;

  border: 1.5px solid #d04c8d;
  border-radius: 50%;
  background: #ffffff;
  cursor: inherit;
  position: relative;

  &:checked::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #d04c8d;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

const Label = styled.span`
  min-width: 0;
  margin-left: 12px;
  color: ${Colors.labelText};
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  white-space: normal;
  overflow-wrap: anywhere;
  text-transform: capitalize;
`;

export default function RadioInput({
  name,
  label,
  margin,
  checked,
  onChange,
  disabled = false,
  data_disabled = false,
}) {
  const isDisabled = disabled || data_disabled;

  return (
    <RadioButtonGroup
      $margin={margin}
      $disabled={isDisabled}
    >
      <RadioButton
        type="radio"
        name={name}
        value={label}
        checked={Boolean(checked)}
        onChange={() => {
          if (!isDisabled) {
            onChange?.();
          }
        }}
        disabled={isDisabled}
      />

      <Label $disabled={isDisabled}>{label}</Label>
    </RadioButtonGroup>
  );
}